<template>
  <div class="">
    <div class="container pt-3 m-auto text-left ">
       
      <form id="form" autocomplete="off" class="form-horizontal" @submit.stop.prevent="validateBeforeSubmit">

        
        <b-row v-if="logro">
          <b-col cols="12">
            <b-form-group v-validate.persist="{ min: 0, max: this.tema?.rango_nota ?? 100 }" name="rango_inicial" id="input-rango_inicial" label="Rango inicial:" label-for="rango_inicial" description="Introduzca valores numéricos.">
              <b-form-input required step="0.01" min="0" :max="this.tema?.rango_nota ?? 100" id="rango_inicial" type="number" v-model="logro.rango_inicial"></b-form-input>
            </b-form-group>
            
            <b-form-group v-validate.persist="{ min: 0, max: this.tema?.rango_nota ?? 100 }" name="rango_final" id="input-rango_final" label="Rango final:" label-for="rango_final" description="Introduzca valores numéricos.">
              <b-form-input required step="0.01" min="0" :max="this.tema?.rango_nota ?? 100" id="rango_final" type="number" v-model="logro.rango_final"></b-form-input>
            </b-form-group>

            <b-form-file v-validate.persist="{ required: true }" name="archivo" required
              v-model="logro.archivo" 
              :state="!logro.archivo ? null : (getExtFile(logro.archivo.name) == 'pdf' ? true : false)"
              placeholder="Elige un archivo o suéltalo aquí..."
              drop-placeholder="Suelta el archivo aquí..." accept=".pdf">
            </b-form-file>

          </b-col>
        </b-row>

        <b-row class="mb-3 mt-2">
          <b-col cols="6">
            <button class="btn btn-block btn-secondary" type="button" @click="cerrar">Cerrar</button>
          </b-col>
          <b-col cols="6">
            <button class="btn btn-block btn-success" type="submit">Guardar</button>
          </b-col>
        </b-row>
      </form>
      
    </div>
  </div>
  
</template>


<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'FeedbackNuevo',
    components: {
      
    },
    props:{
      tema_id:String
    },
    data () {
      return {
          logro : null,
      }
    },
    mounted () {
      this.logro = this.logroVacio
    },
    
    methods:{
        ...mapActions({
            crear: 'temas_adicional/crear',
            setWarning: 'setWarning',
        }),
      ...mapMutations({
        
      }),
      
      validateBeforeSubmit () {
        if (this.logro.archivo && this.getExtFile(this.logro.archivo.name) != "pdf") {
          this.logro.archivo = null;
        }
        this.$validator.validateAll().then(result => {
          if (!result) {
            console.log('validateBeforeSubmit error')
          } else {
            console.log('validateBeforeSubmit no error')

            const form = new FormData();
            form.append("tema_id", this.tema_id)
            form.append("tipo", this.logro.tipo)
            form.append("rango_inicial", this.logro.rango_inicial)
            form.append("rango_final", this.logro.rango_final)
            form.append("archivo", this.logro.archivo, this.logro.archivo.name)
            
            this.crear(form).then(result =>{
                this.setWarning('Feedback creado', { root: true }).then(()=>{
                  this.$emit("actualizar")
                  this.cerrar();
              })
            }).catch(error=>{
              //todo probar si se puede quitar
              console.error("Feedback error result:", error)
            })
          }
        })
      },
      cerrar() {
        this.$emit("cerrar")
      },
      getExtFile(filename) {
        let info = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename) : undefined;
        if (info && info.length) {
          return info[0];
        }
        return undefined;
      },

    },
    computed:{
      ...mapState({
        detalle: state => state.temas.detalle, 
        warning: state => state.warning,
      }),

      logroVacio(){
        return {
          tema_id : this.tema_id,
          tipo : "feedback",
          rango_inicial : 0,
          rango_final:0
        }
      },
      tema() {
        if (this.detalle[this.tema_id]) {
          return this.detalle[this.tema_id];
        }
        return null;
      },
      
      
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>
